import React, { useEffect, useState, memo, useRef } from "react";
import { useDispatch } from 'react-redux';
import { connect } from "react-redux";
import { compose } from "redux";
import { getDepartments } from "../store/actions/departmentActions";
import { Redirect } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";
import Meters from "../components/Meters/Meters";
import DepartmentDashboard from "../components/Dashboards/Department";
import RiskDashboard from "../components/Dashboards/RiskDashboard";
import { resetGotoRiskDashboard, resetGotoBowtie, closeOverlay } from "../store/actions/riskActions";
import { getDepartmentDashboardData } from "../store/actions/dashboardActions";
import { resetDepartmentDashboard } from "../store/actions/departmentActions";
import { setActiveDepartment } from "../store/actions/departmentActions";
import UnitsSideBar from "../components/UnitsSideBar";
import UnitsTopBar from "../components/UnitsTopBar";
import Files from "../components/Files/Files";
import Risk from "./Risk";
import Reports from "./Reports";
import Gantt from "./Gantt";
import Control from "./Control"
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Report from "../components/Report/ReportOverlay";
import ITInventory from "./ITInventory";
import Workflows from "./Workflows";
import WorkflowEditor from "../components/Workflow/WorkflowEditor";
import Workflow from "../components/Workflow/Workflow";
import { Panel } from 'reactflow';
import IncidentList from "../components/Incidents/IncidentList";

function Units(props) {
    const { token, departments, getDepartmentsFN, match, resetGotoRiskDashboardFN, resetGotoBowtieFN, resetDepartmentDashboardFN, setActiveDepartmentId, activeDepartmentId, getDepartmentDashboardDataFN } = props;
    const { id } = useParams();
    const location = useLocation();
    const departmentfromredirect = location.state?.departmentfromredirect;
    const activeMenuItem = location.state?.activeMenuItem;

    const [activeriskforworkflow, setActiveRiskForWorkflow] = useState(null);
    const [activeassetforworkflow, setActiveAssetForWorkflow] = useState(null);

    ////console.log("token:", token);
    //const departments = ["General", "Financial", "Marketing", "Pricing", "IT", "HR", "Project", "Management"];
    const [activeDepartment, setActiveDepartment] = useState("General");
    //const [activeDepartmentId, setActiveDepartmentId] = useState(null);
    //const [activeRiskId, setActiveRiskId] = useState(null);
    //const [selectedDepartment, setSelectedDepartment] = useState(null); // New state for Select component

    const [menuitem, setMenuItem] = useState("dashboards");
    const [isReportOpen, setIsReportOpen] = useState(false);

    const [departmentDashboardData, setDepartmentDashboardData] = useState(null); // State in the parent
    const [generalDashboardData, setGeneralDashboardData] = useState(null); // State in the parent
    



  
    const openReport = () => {
        console.log("Opening report with data:", {
            departments: departments,
            departmentDashboardData: departmentDashboardData,
            riskSummary: departmentDashboardData?.risk_summary
        });

        // Check if there are any risks in the summary
        const hasRisks = departmentDashboardData.risk_summary?.length > 0;
        
        if (!hasRisks) {
            alert("Please approve some risks before generating the report.");
            return;
        }

        setIsReportOpen(true);
    };

    //console.log("departmentDashboardData", departmentDashboardData);


    useEffect(() => {
        //resetDepartmentDashboardFN();
        resetGotoRiskDashboardFN();
        getDepartmentsFN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        //resetDepartmentDashboardFN();
        resetGotoBowtieFN();
        getDepartmentsFN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        //console.log("activeDepartmnetId", activeDepartmentId);
        //console.log("activeDepartmnet", activeDepartment);

        getDepartmentDashboardDataFN(activeDepartmentId);
        //console.log("departmentDashboard data NEW!!!", departmentDashboardData);
    }, [menuitem, activeDepartmentId]);

    

    useEffect(() => {
        if (departmentfromredirect) {
            resetDepartmentDashboardFN();
            //alert(1);
            let actual_department = departments && departments.find(department => department.department_id === departmentfromredirect);
            setActiveDepartment(actual_department.name);
            setActiveDepartmentId(departmentfromredirect);
            //getDepartmentsFN(e.value);
            // setActiveRiskId(null);
            console.log("departmentfromredirect", departmentfromredirect)


        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [departmentfromredirect]);



    useEffect(() => {
        if (departments && departments?.length > 0 && !departmentfromredirect) {
            //alert(0);
            setActiveDepartment(departments[0].name);
            setActiveDepartmentId(departments[0].department_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    /*
    useEffect(() => {
        if (departments && departments?.length > 0) {
            setActiveDepartment(departments[0].name);
            setActiveDepartmentId(departments[0].department_id);
        }
    }, [departments]);
    */

    useEffect(() => {
        if (match.params.id) {
            //setActiveRiskId(match.params.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match.params.id]);

    useEffect(() => {
        if (activeMenuItem) {
            setMenuItem(activeMenuItem);
        }
    }, [activeMenuItem]);

    const changeActiveDepartment = (department_id) => {


        let actual_department = departments && departments.find(department => department.department_id === department_id);
        setActiveDepartment(actual_department.name);
        setActiveDepartmentId(department_id);
        //getDepartmentsFN(e.value);
        //  setActiveRiskId(null);

        //if (history.location.pathname !== '/dashboards') history.push('/dashboards')
    }

    

    return token ? (

        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />

            {/* Row with Sidebar and Dashboard Content */}
            <div className="flex flex-row w-full h-full "> {/* Added padding to start below TopBar */}
                <Sidebar className="fixed left-0 h-screen z-0" /> {/* Start after TopBar */}

                {/* Unit Sidebar - aligns with Sidebar */}
                <UnitsSideBar className="fixed left-0 h-screen z-10 w-[250px] min-w-[250px] max-w-[250px]"
                    setActiveDepartment={changeActiveDepartment}
                    activeDepartmentId={activeDepartmentId}
                    departments={departments}
                />

                {/* Dashboard Content Area */}
                <div className="flex flex-col w-full"> {/* Indent to accommodate Sidebar width */}
                    {/* UnitsTopBar Row */}
                    <UnitsTopBar className="w-full h-16 fixed z-10"
                        menuitem={menuitem}
                        setMenuItem={setMenuItem}
                        activeDepartmentId={activeDepartmentId}
                        departments={departments}
                        openReport={openReport}
                    />

                    {menuitem === "dashboards" ? (
                        <div id="dashboard-content" className="flex flex-col w-full p-4 overflow-auto">
                            <div className="flex flex-wrap w-full">
                                <div className="flex-1">
                                    {activeDepartment !== "General" && !match.params.id && (
                                        <Meters mode="department" department_id={activeDepartmentId} />
                                    )}
                                    {match.params.id && <Meters mode="risk" risk_id={match.params.id} />}
                                </div>
                            </div>

                            {activeDepartment !== "General" && !match.params.id && (
                                <DepartmentDashboard
                                    department_id={activeDepartmentId}
                                    setDepartmentDashboardData={setDepartmentDashboardData}
                                />
                            )}
                            {/* {match.params.id && <RiskDashboard match={match} />}
                        </div>
                    ) : menuitem === "risk" ? (
                        <Risk activeDepartmentId={activeDepartmentId} activeDepartment={activeDepartment} activeriskforworkflow={activeriskforworkflow} setActiveRiskForWorkflow={setActiveRiskForWorkflow} />
                    ) : menuitem === "files" ? (
                        <Files department_id={activeDepartmentId} />
                    ) : menuitem === "controls" ? (
                        <Control />
                    ) : menuitem === "inventory" ? (
                        <ITInventory activeassetforworkflow={activeassetforworkflow} setActiveAssetForWorkflow={setActiveAssetForWorkflow} />
                    ) : menuitem === "workflows" ? (
                        <Workflow setMenuItem={setMenuItem} department_id={activeDepartmentId} setActiveRiskForWorkflow={setActiveRiskForWorkflow} setActiveAssetForWorkflow={setActiveAssetForWorkflow} />
                    ) : (
                        <Gantt activeDepartmentId={activeDepartmentId} activeDepartment={activeDepartment} />
                    )} */}
                     {match.params.id && <RiskDashboard match={match} />}
                        </div>
                    ) : menuitem === "risk" ? (
                        <Risk activeDepartmentId={activeDepartmentId} activeDepartment={activeDepartment} />
                    ) : menuitem === "files" ? (
                        <Files department_id={activeDepartmentId} />
                    ) : menuitem === "controls" ? (
                        <Control />
                    ) : menuitem === "inventory" ? (
                        <ITInventory />
                    ) : menuitem === "workflows" ? (
                        <Workflows />
                    ) : menuitem === "incidents" ? (
                        <IncidentList activeDepartmentId={activeDepartmentId} activeDepartment={activeDepartment}/>
                    ) : menuitem === "workflow-editor" ? (
                        <div className="flex-1 overflow-auto mt-16">
                            <WorkflowEditor 
                                setMenuItem={setMenuItem}
                                setActiveRiskForWorkflow={setActiveRiskForWorkflow}
                                setActiveAssetForWorkflow={setActiveAssetForWorkflow}
                            />
                        </div>
                    ) : menuitem === "create_report" ? (
                        <Reports />
                    ) : (
                        <Gantt activeDepartmentId={activeDepartmentId} activeDepartment={activeDepartment} />
                    )}
                </div>
            </div>

            
        </div>

    ) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    console.log(state.department)
    return {

        token: state.auth.token,

        // departments: state.department.departments.filter(
        //     (dept) => dept.name !== "IT"
        // ),

        departments: state.department.departments,
        activeDepartmentId: state.department.activeDepartmentId,



    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDepartmentsFN: () => dispatch(getDepartments()),
        resetGotoRiskDashboardFN: () => dispatch(resetGotoRiskDashboard()),
        resetGotoBowtieFN: () => dispatch(resetGotoBowtie()),
        resetDepartmentDashboardFN: () => dispatch(resetDepartmentDashboard()),
        setActiveDepartmentId: (department_id) => dispatch(setActiveDepartment(department_id)),
        getDepartmentDashboardDataFN: (department_id) => dispatch(getDepartmentDashboardData(department_id)),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Units);
